import { useCallback } from 'react';

import { useIsomorphicLayoutEffect } from 'utils/hooks/useIsomorphicLayoutEffect';

import { ViewportSize, getViewportSize } from './getViewportSize';

export function useViewportSizeEffect(callback: (size: ViewportSize) => void) {
  const handleResize = useCallback(() => {
    callback(getViewportSize());
  }, [callback]);

  useIsomorphicLayoutEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize();

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [handleResize]);
}
